/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'SDSignup' store object.
 * @namespace SDSignupSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UASDSignup';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDSignupSelectors
   */
  static postSdCreateUser = state => state[selectors.moduleIdentifier].postSdCreateUser.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDSignupSelectors
   */
  static isFetchingPostSdCreateUser = state =>
    state[selectors.moduleIdentifier].isFetchingPostSdCreateUser.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof SDSignupSelectors
   */
  static postSdCreateUserError = state =>
    state[selectors.moduleIdentifier].postSdCreateUserError.payload;
}
